module.exports = __webpack_public_path__ + "assets/img/career-office.c6fda023.jpg";